<i18n>
{
  "no": {
  "whyDoWeNeedYourNationalIdNumber": "Hvorfor trenger vi fødselsnummeret ditt?",
  "info": "For Telenors tjenester er vi påbelagt av norske myndigheter å verifisere din identitet. Derfor trenger vi å bekrefte fødselsnummeret ditt mot Folkeregisteret.",
  "info2": "For å forhindre svindel varsler vi deg ved å sende en SMS til mobilnummeret tilknyttet ditt fødselsnummer.",
  "privacy": "Les mer om personvern",
  "back": "Tilbake"
  },
  "en": {
  "whyDoWeNeedYourNationalIdNumber": "Why do we need your national ID number?",
  "info": "Telenor are required by the Norwegian authorities to verify your identity. Therefore we need to verify your national identification number in the National Registry.",
  "info2": "To prevent fraud we alert you by sending an SMS to the mobile phone numbers linked to your national ID.",
  "privacy": "Read more about privacy",
  "back": "Back"
  }
}
</i18n>

<template>
  <InfoScreen>
    <TnHeading type="h1" size="m" class="margin-bottom-l">
      {{ t('whyDoWeNeedYourNationalIdNumber') }}
    </TnHeading>
    <TnParagraph class="margin-bottom-l">{{ t('info') }}</TnParagraph>
    <TnParagraph class="margin-bottom-l">{{ t('info2') }}</TnParagraph>

    <div class="info-links">
      <BackLink :text="t('back')" />

      <TnLink v-if="environment.privacyUrl" :href="environment.privacyUrl" :text="t('privacy')" />
    </div>
  </InfoScreen>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { TnHeading, TnLink, TnParagraph } from '@telenornorgeinternal/telegrafen-vue3-core';

import InfoScreen from '@/components/InfoScreen.vue';
import BackLink from '@/components/BackLink.vue';
import { EnvironmentService } from '@/environment';

const { t } = useI18n();

const environment = ref<Record<string, string>>({});

onMounted(async () => {
  environment.value = await EnvironmentService.getEnvironment();
});
</script>

<style scoped>
/* Stack the links so "back" renders first, with the privacy link underneath. */
.info-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
</style>
